const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-store-hours'] = {
        c: () => require('partner/modules/hei-store-hours/hei-store-hours.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-store-hours',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-store-hours'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-store-hours|hei-store-hours'] = {
                c: () => require('partner/modules/hei-store-hours/hei-store-hours.view.tsx'),
                cn: '__local__-__local__-hei-store-hours'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };